import React from "react";


import './carga.css';

export default class SelectComponent extends React.Component {


  constructor(props) {
    super(props);

    const {onlyCarga} = props;

    this.onChangeCapture(onlyCarga);

  }
  
  onChangeCapture = (e) => {
    this.props.onChange(e);
  }

  render() {
    return (<div className="carga"></div>);
  }

}